/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Specialcasesandmisc3Inputs */

const de__field_specialcasesandmisc3 = /** @type {(inputs: _Field_Specialcasesandmisc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besonderheiten`)
};

/**

* @param {_Field_Specialcasesandmisc3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_specialcasesandmisc3 = /** @type {((inputs?: _Field_Specialcasesandmisc3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Specialcasesandmisc3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_specialcasesandmisc3(inputs)
});
export { _field_specialcasesandmisc3 as "_field_specialCasesAndMisc" }